import React from 'react';
import Cookies from 'js-cookie';
import { Popconfirm, message, Divider } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import DepartmentAdd from './components/DepartmentAdd';
import { post, postFrom, config } from '../../axios';
import { dicMerchantDepartmentStatus } from '../../axios/dictionaries';

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: {
                keyword: '', //关键字
                name: '', //部门名称
                pageSize: 10
            }, //搜索参数
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
            createOrEdit: false, //默认为创建
            isMerchant: false, //判断是否为商户显示新增
            merchantIdOptionData: [], //商户下拉搜索条件容器
            merchantId: '', //当前商户id
        }
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
            createOrEdit,
            isMerchant,
            merchantIdOptionData,
            merchantId
        } = this.state;
        let nowSearchData = [].concat(searchData({ merchantIdOptionData }));
        let findPageData = [].concat(columns({ current, handleEdit: this.handleEdit, handleDelete: this.handleDelete, isMerchant }));



        if (isMerchant) { //商户
            nowSearchData.splice(0, 1);
            findPageData.splice(2, 1);
        }

        return (
            <PageWrap
                loading={loading}
            >
                <div className={`search-wrapper ${isMerchant ? "" : "flex-justify-end"}`}>
                    {
                        isMerchant ?
                            <div className="search-btn-list">
                                <AuthButton authkey="h-2-3" type="primary" icon="plus" onClick={() => { this.setState({ showAddModal: true, createOrEdit: false }) }}>新增</AuthButton>
                            </div>
                            : ''
                    }

                    <SuperForm
                        data={nowSearchData}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                        showCancel={!isMerchant ? "重置" : false}
                    />
                </div>
                <TableDOM
                    columns={findPageData}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />
                <DepartmentAdd
                    onRef={ref => this.departmentAddRef = ref}
                    visible={showAddModal}
                    handlecreateOrEdit={createOrEdit}
                    handleGetList={this.handleSearch}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                    parentMerchantId={merchantId}
                />
            </PageWrap>
        )
    }

    componentDidMount() {
        this.handleSearch();
        this.merchanttListsQuery();
        if (Cookies.get('loginData')) {
            let loginData = JSON.parse(Cookies.get('loginData'))
            for (let key in loginData) {
                if (key == 'merchantId' && loginData[key]) { //商户
                    this.setState({ isMerchant: true, merchantId: loginData[key] })
                }
            }
        }
    }

    handleEdit = (id, platformisAdmin) => { //编辑
        this.setState({ showAddModal: true, createOrEdit: true })
        this.departmentAddRef.loadPack({ id, platformisAdmin })
    }

    handleDelete = (id) => { //删除

        this.setState({ loading: true });
        let data = { merchantdepartmentId: id };
        postFrom({
            url: config.API_merchantdepartment_delMerchantDepartment,
            data,
        }).then(res => {
            this.setState({ loading: false });
            if (res && res.code) {
                message.error(res.message || '接口异常');
                return;
            }
            this.handleSearch();
            message.success(`删除成功`);
        }).catch(err => {
            message.error(err.message || '接口异常');
            this.setState({ loading: false });
        })
    }


    merchanttListsQuery = () => { //商户列表查询

        postFrom({
            url: config.API_merchant_findAll,
            data: {}
        }).then(res => {
            let result = [];
            for (let key in res) {
                result.push({
                    title: res[key]['name'],
                    value: res[key]['id']
                })
            }
            this.setState({ merchantIdOptionData: result });
        }).catch(err => {
            message.error(err.message || '获取商户列表失败');
        })
    }


    handleSearch = (values = {}) => { //表单搜索/分页

        let { params, current, merchantId } = this.state;
        let data = {};
        values.merchantId = values.merchantId == -1 ? merchantId : values.merchantId;
        if (values.current) {
            data = Object.assign(params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({
            url: config.API_merchantdepartment_findPage,
            data,
        }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

}

const searchData = ({ merchantIdOptionData }) => [
    {
        tagName: 'Select',
        formConfig: { name: 'merchantId' },
        attribute: { placeholder: '请选择商户', style: { width: '160px' }, }, //onChange: (value) => {handleChange(value)}
        optionData: merchantIdOptionData
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字 ', style: { width: '160px' } },
        title: '在部门名称内模糊查询'
    },

];
const columns = ({ current, handleEdit, handleDelete, isMerchant }) => [

    {
        title: '部门',
        dataIndex: 'name'
    },
    {
        title: '使用状态',
        dataIndex: 'status',
        render(text, record, index) {

            let now = dicMerchantDepartmentStatus.find(item => parseInt(item.value) === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '商户',
        dataIndex: 'merchantName'
    },
    {
        title: '操作',
        dataIndex: 'action',
        render(text, record, index) {
            return (<div>
                {
                    isMerchant ?
                        <div>
                            <AuthButton authkey="h-2-2"><span className="showClickDetail" onClick={() => { handleEdit(record.id) }}>编辑</span></AuthButton>
                            <Divider type="vertical" />
                            <AuthButton authkey="h-2-4">
                                <Popconfirm placement="top" title={"确定删除吗？"} onConfirm={() => { handleDelete(record.id) }} okText="确定" cancelText="不了">
                                    <span className="showClickDetail">删除</span>
                                </Popconfirm>
                            </AuthButton>
                        </div>
                        :
                        null
                }


            </div>)
        }

    }
];



// WEBPACK FOOTER //
// ./src/page/Merchant/Department.js